export default __webpack_public_path__ + "static/media/close.a1ada3e0.svg";